import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DurationPipe } from '../../pipes/duration.pipe';
import { TimerToastComponent } from '../timer-toast/timer-toast.component';
import { ThemeService } from '../../../core/services/theme.service';
import { TimerTypeEnum } from '../../../theme/enums/timer-type.enum';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'idh-timer',
  templateUrl: 'timer.component.html',
  styleUrls: ['timer.component.scss'],
  imports: [DurationPipe, TimerToastComponent, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'hostClass()',
  },
})
export class TimerComponent {
  private readonly themeService = inject(ThemeService);
  readonly theme = this.themeService.themeSig;
  seconds = input.required<number>();
  readonly TimerType = TimerTypeEnum;
  private readonly warningThreshold = 300;
  private readonly dangerThreshold = 0;
  readonly iconVisible = computed(() => {
    const s = this.seconds();
    return s !== undefined && s <= this.warningThreshold;
  });
  readonly timerState = computed<TimerState>(() => {
    const s = this.seconds();
    if (s === undefined) return 'primary';

    if (s == this.dangerThreshold) return 'danger';
    if (s < this.warningThreshold) return 'warning';
    return 'primary';
  });
  readonly themeClass = computed(() => this.theme().navClass || 'theme-default');
  readonly hostClass = computed(() => {
    const themeClass = this.themeClass();
    return ['idh-timer', themeClass].filter(Boolean).join(' ');
  });
}

type TimerState = 'primary' | 'warning' | 'danger';
